<template>
    <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
        <side-bar :background-color="sidebarBackground" short-title="Teste" title="Teste">
            <template slot="links">
                <sidebar-item title="Início" :link="{name: 'Início',icon: 'fas fa-home',path: '/inicio'}"/>
                <sidebar-item title="Pesquisa avançada" :link="{name: 'Pesquisa avançada', icon: 'fas fa-search', path: '/pesquisa'}"/>
                <sidebar-item title="Calendário de diários" :link="{name: 'Calendário de diários', icon: 'fas fa-calendar-alt', path: '/calendario'}"/>
            </template>
        </side-bar>
        <div class="main-content" :data="sidebarBackground">
            <dashboard-navbar></dashboard-navbar>
            <div @click="toggleSidebar">
                <fade-transition :duration="200" origin="center top" mode="out-in">
                    <router-view></router-view>
                </fade-transition>
            </div>
        </div>
    </div>
</template>
<script>
  import DashboardNavbar from './DashboardNavbar.vue';
  import {FadeTransition} from 'vue2-transitions';
  import {getDadosEntidade} from '@/api/inicio'

  export default {
    components: {
      DashboardNavbar,
      FadeTransition
    },
    data() {
      return {
        sidebarBackground: 'vue'
      };
    },
    methods: {
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      },
      getEntidade() {
        getDadosEntidade().then(response => {
          if (response.status) {
            this.$store.commit('SET_ENTIDADE', response.data);
          }
        }).catch(error => {
          //console.log(error);
        }).finally(finalit => {

        })
      }
    },
    computed: {
      site() {
        return this.$store.getters.site;
      },
      entidade() {
        return this.$store.getters.entidade;
      }
    },
    created() {
      this.getEntidade();
      window.document.title = this.site.title + ' - ' + this.entidade.ent_nome;
    },
  };
</script>
<style lang="scss">
</style>
